import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { createSelectorCreator, defaultMemoize } from 'reselect';
import Radium from 'radium';

import * as defaultStyles from '../../styles';
import { request } from '../../containers/actions';
import {
    setItems, addItem, removeItem, editItem, toggleItem, toggleItemSelection,
    setSelectedItems, fixSelection
} from './actions';
import mainReducer from './reducer';

// //@Radium
class ListItem extends React.PureComponent {
    static contextTypes = {
        store: PropTypes?.object,
    }

    isChild(item, parent) {
        if (item?.parent === parent?.id)
            return true;
        while (item?.parent) {
            item = this?.props?.items[item?.parent];
            if (item?.parent === parent?.id)
                return true;
        }
        return false;
    }

    render() {
        const { colorCode } = this?.props;
        const childrenCount = _.countBy(
            _.values(this?.props?.items),
            _item => _item?.parent === this?.props?.item?.id,
        )['true'];
        const selectedCount = _.countBy(
            _.values(this?.props?.items),
            _item => (
                this?.isChild?.bind(this)(_item, this?.props?.item) &&
                _.has(this?.props?.selected, _item?.id)
            ),
        )['true'];
        return <li style={styles?.li}>
            <div
                key={'item-' + this?.props?.item?.id}
                style={{
                    ..._.has(this?.props?.selected, this?.props?.item?.id) ? styles?.selectedItem : styles?.item,
                    // backgroundColor: this.props.index % 2 === 0
                    //     ? styles.item.backgroundColor[colorCode]
                    //     : (new Color(styles.item.backgroundColor[colorCode])).darken(.03),
                    ':hover': {
                        backgroundColor: defaultStyles.highlightColor,
                    },
                }}
                onClick={async event => {
                    if (event.defaultPrevented)
                        return;
                    event.preventDefault();
                    if (this.props.multiSelection) {
                        await this?.context?.store?.dispatch(toggleItemSelection(
                            this?.props?.item,
                            this?.props?.resource,
                            this?.props?.elementId,
                        ));
                    }
                    else {
                        await this?.context?.store?.dispatch(setSelectedItems(
                            this?.props?.selected[0] === this?.props?.item?.id ? [] : [this?.props?.item?.id],
                            this?.props?.resource,
                            this?.props?.elementId,
                        ));
                    }
                    this?.props?.handleSelected();
                }}>
                {this?.props?.item?.label ? this?.props?.item?.label?.persian() : '-'}
                {selectedCount ? ` (${selectedCount?.persian()})` : null}
                {childrenCount
                    ? <span
                        style={{ cursor: 'pointer' }}
                        onClick={event => {
                            if (event.defaultPrevented)
                                return;
                            event.preventDefault();
                            this.context.store.dispatch(toggleItem(
                                this.props.item,
                                this.props.resource,
                                this.props.elementId,
                            ));
                        }}>
                        {this.props.opened[this.props.item.id] ? '▼' : '◀'}
                    </span>
                    : null
                }
                {this.props.readonly
                    ? null
                    : <span>
                        <div
                            key='delete'
                            style={styles.leftAction}
                            onClick={event => {
                                event.preventDefault();
                                this.props.removeItem(this.props.item);
                            }}>
                            <i className='fa-trash-o'></i>
                        </div>
                        <div
                            key='edite'
                            style={styles.leftAction}
                            onClick={event => {
                                event.preventDefault();
                                this.props.editItem(this.props.item);
                            }}>
                            <i className='fa-edit'></i>
                        </div>
                        {this.props.tree
                            ? <div
                                key='add'
                                style={styles.rightAction}
                                onClick={event => {
                                    event.preventDefault();
                                    this.props.addItem(this.props.item);
                                }}>
                                <i className='fa-plus'></i>
                            </div>
                            : null
                        }
                    </span>
                }
            </div>
            {this?.props?.opened[this?.props?.item?.id]
                ? <DummyTag
                    {...this?.props}
                    parent={this?.props?.item?.id}
                    colorCode={1 - colorCode}
                />
                : null
            }
        </li>;
    }
}

class DummyTag extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    checkSearch(item) {
        if (_.includes(item?.label ? item?.label.persian() : '-', this?.props?.searchTerm))
            return true;
        return _.some(
            _.filter(
                _.values(this?.props?.items),
                item_ => item_.parent === item?.id,
            ),
            item => this?.checkSearch(item),
        );
    }

    render() {
        const items = _.filter(
            _.values(this?.props?.items),
            item => item?.parent === this?.props?.parent && this?.checkSearch(item),
        );
        // const items = this?.props?.items.filter(item => item?.parent === this?.props?.parent && this?.checkSearch(item))
        return <ul
            style={{
                ...styles.ul,
                paddingRight: this?.props?.parent
                    ? undefined
                    : 'unset',
            }}
        >
            {_.map(
                // items?.sort((item1, item2) => item1?.label?.persian()?.localeCompare(item2?.label?.persian())),
                items?.sort((item1) => item1?.id).reverse(),
                (item, index) => <ListItem key={index} {...this?.props} item={item} index={index} />,
            )}
        </ul>;
    }
}


class Tree extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
        pending: PropTypes.number,
    }

    static defaultProps = {
        readonly: false,
        header: true,
        tree: false,
        itemLabel: 'title',
        multiSelection: true,
        limit: {},
        combobox: false,
        style: {},
        itemsStyle: { maxHeight: '30em', overflowY: 'auto' },
        requiredFields: [],
    }

    state = {
        resource: this.props.resource + ':' + queryString.stringify({ ...this.props.filter, limit: 100000 }),
        searchTerm: '',
        showSearch: false,
    }

    constructor(props) {
        super(props);
        this.handleSelected = this.handleSelected.bind(this);
        this.addItem = this.addItem.bind(this);
        this.removeItem = this.removeItem.bind(this);
        this.editItem = this.editItem.bind(this);
    }

    async componentDidMount() {
        this.fetch.bind(this)();
        const close = event => {
            if (this.searchButton && this.searchButton.contains(event.target)) {
                event.stopPropagation();
                event.preventDefault();
                this.setState({
                    open: !this.state.showSearch ? true : this.state.open,
                    showSearch: !this.state.showSearch,
                    searchTerm: this.state.showSearch ? '' : this.state.searchTerm,
                });
            }
            if (
                this.props.combobox &&
                !this.state.searchTerm &&
                this.refs.leftActions &&
                !this.refs.leftActions.contains(event.target) &&
                this.refs.dropdown &&
                !this.refs.dropdown.contains(event.target) &&
                (this.state.showSearch || this.state.open)
            ) {
                this.setState({ showSearch: false, open: false });
                event.preventDefault();
            }
        };
        if (this.props.initial) {
            await this.context.store.dispatch(setSelectedItems(
                this.props.initial,
                this.props.resource,
                this.props.elementId,
            ));
        }
        window.addEventListener('click', close, true);
        this.cleanUp = () => {
            window.removeEventListener('click', close, true);
        };
    }

    componentWillUnmount() {
        this.cleanUp();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.items === 0 && this.props.items) {
            this.context.store.dispatch([
                fixSelection(this.state.resource, this.props.elementId),
            ]);
        }
        if (prevProps.resource !== this.props.resource ||
            !_.isEqual(prevProps.filter, this.props.filter)) {
            this.fetch.bind(this)();
        }
        if (this.state.showSearch && !prevState.showSearch) {
            this.refs.searchTerm.focus();
        }
        if (!this.state.showSearch && prevState.showSearch) {
            this.setState({ searchTerm: '' });
        }
        if (!this.state.open && this.state.showSearch) {
            this.setState({ showSearch: false });
        }
    }

    async fetch() {
        const resource = this.props.resource + ':' + queryString.stringify({ ...this.props.filter, limit: 100000 });
        if (this.props.staticItems) {
            this.context.store.dispatch([
                setItems(this.props.staticItems, resource, this.props.elementId),
                setItems(this.props.staticItems, this.props.resource, this.props.elementId),
            ]);
            return;
        }
        this.setState({ resource });
        if (this.props.items === 0)
            return;
        if (this.context.store.getState().getIn(['trees', 'items', resource])) {
            this.context.store.dispatch([
                fixSelection(resource, this.props.elementId),
                setItems(this.context.store.getState().getIn(['trees', 'items', resource]), this.props.resource, this.props.elementId),
            ]);
            return;
        }
        let items = {};
        try {
            await this.context.store.dispatch(setItems(0, resource, this.props.elementId));
            items = (await this.context.store.dispatch(
                request(`/${this.props.resource}/?` + queryString.stringify({ ...this.props.filter, limit: 100000 })),
            )).results;
        }
        catch (exception) {
            return;
        }
        items = _.mapKeys(items, item => item.id);
        items = _.mapValues(items, item => ({
            ...item,
            label: _.isFunction(this.props.itemLabel)
                ? this.props.itemLabel(item)
                : _.isArray(this.props.itemLabel)
                    ? _.map(this.props.itemLabel, field => item[field]).join(' - ')
                    : item[this.props.itemLabel],
        }));
        this.context.store.dispatch([
            setItems(items, resource, this.props.elementId),
            setItems(items, this.props.resource, this.props.elementId),
        ]);
    }

    async addItem(parent) {
        parent = parent ? parent.id : null;
        const label = prompt(window.gettext('Enter a title:'));
        if (!label) {
            return;
        }
        const item = await this.context.store.dispatch(request({
            path: `/${this.props.resource}/`,
            body: {
                [this.props.itemLabel]: label,
                parent,
                ..._.mapValues(
                    _.pickBy(this.props.filter, (__, key) => _.includes(this.props.requiredFields, key)),
                    id => ({ id }),
                ),
            },
            method: 'POST',
        }));
        this.context.store.dispatch(addItem(
            {
                ...item,
                label: _.isFunction(this.props.itemLabel) ? this.props.itemLabel(item) : item[this.props.itemLabel],
            },
            this.state.resource,
            this.props.elementId,
        ));
    }

    async removeItem(item) {
        const confirmed = window.confirm(window.gettext(
            'Are you sure you want to delete this item?',
        ));
        if (!confirmed)
            return;
        await this.context.store.dispatch(request({
            path: `/${this.props.resource}/${item.id}/`,
            method: 'DELETE',
        }));
        this.context.store.dispatch(removeItem(
            item,
            this.state.resource,
            this.props.elementId,
        ));
    }

    async editItem(item) {
        const label = prompt(`در حال تغییر عنوان (${item.label})`);
        if (!label) {
            return;
        }
        const updatedItem = await this.context.store.dispatch(request({
            path: `/${this.props.resource}/${item.id}/`,
            body: {
                [this.props.itemLabel]: label,
            },
            method: 'PATCH',
        }));

        const payloadToDispatch = {
            ...item,
            ...updatedItem,
            label: _.isFunction(this.props.itemLabel) ? this.props.itemLabel(updatedItem) : updatedItem[this.props.itemLabel],
        };

        this.context.store.dispatch(editItem(
            payloadToDispatch,
            this.state.resource,
            this.props.elementId,
        ));

    }
    

    handleSelected() {
        this.setState({ open: false });
    }

    render() {
        if (!this.context.store.getState().getIn(['trees', 'items', this.state.resource]))
            return <div>
                {window.gettext('Loading')}&nbsp;
                <i className='fa-spin fa-spinner'></i>
            </div>;
        const items_ = this.context.store.getState().getIn(['trees', 'items', this.state.resource]);
        if (this.items_ !== items_) {
            this.items_ = items_;
            this.items = items_.toJS();
        }
        const selected_ = this.props.selected;
        if (this.selected_ !== selected_) {
            this.selected_ = selected_;
            this.selected = selected_.toJS ? selected_.toJS() : selected_;
        }
        const opened_ = this.props.opened;
        if (this.opened_ !== opened_) {
            this.opened_ = opened_;
            this.opened = opened_.toJS ? opened_.toJS() : opened_;
        }

        return <div style={{ boxShadow: defaultStyles.button.boxShadow, position: 'relative', ...this.props.style }}>
            {this.props.header
                ? <div
                    style={{
                        ...styles.item,
                        backgroundColor: 'white',
                        height: 'unset',
                        minHeight: '2.5em',
                        paddingTop: '.25em',
                        position: 'relative',
                    }}>
                    <div
                        style={{
                            fontSize: '1.05em',
                            position: 'absolute',
                            right: this.props.readonly ? '.25em' : '2em',
                            top: '.33em',
                            color: _.size(this.selected) > 0 ? defaultStyles.thirdColor : '#9a9a9a',
                        }}>
                        <span ref='label'>
                            {this.props.label}
                        </span>
                        {
                            _.countBy(
                                _.values(this.items),
                                item => _.has(this.selected, item.id),
                            )['true'] > 0
                                ? ': '
                                : null
                        }
                    </div>
                    {this.props.readonly
                        ? null
                        : <span>
                            <div
                                key='add'
                                style={styles.rightAction}
                                onClick={() => this.addItem.bind(this)()}>
                                <i className='fa-plus'></i>
                            </div>
                        </span>
                    }
                    <span ref='leftActions'>
                        {this.props.combobox
                            ? <i
                                style={styles.leftAction}
                                className='fa-chevron-down'
                                onClick={() => this.setState({ open: !this.state.open })}>
                            </i>
                            : null
                        }
                        <div
                            key='search'
                            ref={component => this.searchButton = component}
                            style={{
                                ...styles.leftAction,
                                direction: 'ltr',
                                position: 'relative',
                                height: undefined,
                                marginTop: '-.35em',
                                width: this.state.showSearch ? 'calc(100% + .69em)' : '4em',
                                marginLeft: this.state.showSearch
                                    ? this.props.combobox ? '-1.84em' : '-.3em'
                                    : '0',
                                marginRight: '-.4em',
                                transition: 'margin-left 400ms, width 400ms',
                            }}>
                            <i
                                className={`fa-${this.state.showSearch ? 'times' : 'search'}`}
                                style={{
                                    position: 'absolute',
                                    left: '.5em',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                }}>
                            </i>
                            <input
                                ref='searchTerm'
                                placeholder={this.refs.label ? this.refs.label.innerText : this.props.label}
                                style={{
                                    ...defaultStyles.field,
                                    padding: this.state.showSearch ? '.25em' : '0',
                                    opacity: this.state.showSearch ? '1' : '0',
                                    width: this.state.showSearch ? '100%' : '0',
                                    height: '2.5em',
                                    marginBottom: '0',
                                    transition: 'width 400ms, opacity 400ms',
                                    direction: 'rtl',
                                }}
                                value={this.state.searchTerm}
                                onChange={({ target: { value } }) => this.setState({ searchTerm: value.persian() })}
                            />
                        </div>
                    </span>
                    <br />
                    {/* selected */}
                    <div
                        key='selected'
                        style={{
                            overflow: 'hidden',
                            width: '100%',
                            borderBottom: this.props.combobox ? undefined : '0.0625em solid #cacaca',
                        }}>
                        {_.map(
                            this.selected,
                            (value, key) => <div
                                key={key}
                                style={{
                                    marginRight: '.5rem',
                                    float: 'right',
                                    clear: 'right',
                                    width: 'calc(100% - .5rem)',
                                }}>
                                <i
                                    className='fa-times'
                                    onClick={() => this.context.store.dispatch(toggleItemSelection(
                                        key,
                                        this.props.resource,
                                        this.props.elementId,
                                    ))}>
                                </i>
                                &nbsp;
                                {(value || '').persian()}
                            </div>,
                        )}
                    </div>
                </div>
                : null
            }
            {/* drop down menu */}
            <div
                ref='dropdown'
                style={this.props.combobox
                    ? {
                        position: 'absolute',
                        top: '2.4em',
                        zIndex: '10',
                        width: '100%',
                        backgroundColor: 'white',
                        maxHeight: this.state.open ? '18em' : '0em',
                        boxShadow: 'rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px',
                        overflowY: 'auto',
                        overflowX: 'hidden',
                        boxSizing: 'border-box',
                        transition: 'max-height 200ms',
                        pointerEvents: this.state.open ? undefined : 'none',
                    }
                    : this.props.itemsStyle
                }>
                <DummyTag
                    handleSelected={this.handleSelected}
                    parent={this.props.tree ? null : undefined}
                    addItem={this.addItem}
                    removeItem={this.removeItem}
                    editItem={this.editItem}
                    colorCode={1}
                    resource={this.state.resource}
                    searchTerm={this.state.searchTerm}
                    items={this.items}
                    multiSelection={this.props.multiSelection}
                    elementId={this.props.elementId}
                    selected={this.selected}
                    opened={this?.opened ? this?.opened : false}
                    readonly={this.props.readonly}
                    tree={this.props.tree}
                />
            </div>
        </div>;
    }
}

const styles = {};
styles.ul = {
    margin: '0',
    paddingRight: '2.5em',
    clear: 'both',
};
styles.li = {
    display: 'block',
    listStyleType: 'none',
    cursor: 'pointer',
    clear: 'both',
};
styles.item = {
    fontSize: '.95em',
    width: '100%',
    backgroundColor: 'white',
    color: 'black',
    paddingRight: '.4em',
    paddingLeft: '.4em',
    paddingBottom: '.25em',
    paddingTop: '.25em',
    boxSizing: 'border-box',
};
styles.selectedItem = {
    ...styles.item,
    color: defaultStyles.fourthColor,
};
styles.itemAction = {
    display: 'flex',
    cursor: 'pointer',
    fontSize: '1.2em',
    color: 'rgba(100, 100, 100, .7)',
    alignItems: 'center',
    marginLeft: '.25em',
    marginRight: '.25em',
    height: '1.5em',
    ':hover': {
        color: 'black',
    },
};
styles.leftAction = {
    ...styles.itemAction,
    float: 'left',
};
styles.rightAction = {
    ...styles.itemAction,
    float: 'right',
};

function isEqual(currentVal, previousVal) {
    if (!currentVal || !previousVal)
        return currentVal === previousVal;
    if (currentVal instanceof Map)
        return currentVal === previousVal;
    let constantItemLabel = true;
    if (currentVal.constantItemLabel !== undefined)
        constantItemLabel = currentVal.constantItemLabel;
    return _.every(
        _.union(_.keys(currentVal), _.keys(previousVal)),
        key => (
            (key === 'itemLabel' && constantItemLabel) ||
            (_.includes(['filter', 'style'], key) && _.isEqual(currentVal[key], previousVal[key])) ||
            currentVal[key] === previousVal[key]
        ),
    );
}
const createSelector = createSelectorCreator(defaultMemoize, isEqual);

const makeTreeProps = () => {
    return createSelector(
        [
            (state, props) => state.getIn(['trees', 'items', props.resource + ':' + queryString.stringify({ ...props.filter, limit: 100000 })]),
            (__, props) => props,
        ],
        (items, props) => {
            if (props.storeState)
                return { items, ...props, ...props.storeState.toObject() };
            else
                return { items, ...props };
        },
    );
};

const makeMapStateToProps = () => {
    const getProps = makeTreeProps();
    return (state, props) => getProps(state, props);
};

const ConnectedTree_ = connect(makeMapStateToProps, undefined, (stateProps, dispatchProps) => ({ ...stateProps, ...dispatchProps }))(Tree);
const ConnectedTree = ({ store, ...props }) => <ConnectedTree_ storeState={store} {...props} />;
export default ConnectedTree;

export const initialState = {};

export const reducer = mainReducer;

export const component = props => <div style={{ marginTop: '1em' }}><ConnectedTree {...props} /></div>;
//Radium(ListItem);
//Radium(Tree);